import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig, navigation } from '../data/mockData';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-primary-deep text-slate-300 pt-16 pb-8 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="flex flex-col gap-5">
            <div className="flex items-center gap-2.5">
              <div className="text-primary">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                  <path d="M39.5563 34.1455V13.8546C39.5563 15.708 36.8773 17.3437 32.7927 18.3189C30.2914 18.916 27.263 19.2655 24 19.2655C20.737 19.2655 17.7086 18.916 15.2073 18.3189C11.1227 17.3437 8.44365 15.708 8.44365 13.8546V34.1455C8.44365 35.9988 11.1227 37.6346 15.2073 38.6098C17.7086 39.2069 20.737 39.5564 24 39.5564C27.1288 39.5564 30.2914 39.2069 32.7927 38.6098C36.8773 37.6346 39.5563 35.9988 39.5563 34.1455Z"/>
                </svg>
              </div>
              <h2 className="text-lg font-semibold tracking-tight text-white">{siteConfig.name}</h2>
            </div>
            <p className="text-slate-400 leading-relaxed text-sm">
              {siteConfig.description}
            </p>
            <div className="flex gap-3">
              <a className="size-9 rounded-md bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors" href={siteConfig.social.website} aria-label="Website">
                <span className="material-symbols-outlined text-base">public</span>
              </a>
              <a className="size-9 rounded-md bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors" href={siteConfig.social.linkedin} aria-label="LinkedIn">
                <span className="material-symbols-outlined text-base">share</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold uppercase tracking-wide text-slate-200">Quick Links</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              {navigation.footer.quickLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold uppercase tracking-wide text-slate-200">Legal & Info</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              {navigation.footer.legal.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold uppercase tracking-wide text-slate-200">Contact Info</h4>
            <div className="flex items-start gap-2.5 text-slate-400 text-sm">
              <span className="material-symbols-outlined text-base text-accent-gold mt-0.5">location_on</span>
              <span dangerouslySetInnerHTML={{ __html: siteConfig.contact.address.replace(',', ',<br/>') }} />
            </div>
            <div className="flex items-center gap-2.5 text-slate-400 text-sm">
              <span className="material-symbols-outlined text-base text-accent-gold">call</span>
              <span>{siteConfig.contact.phone}</span>
            </div>
            <div className="flex items-center gap-2.5 text-slate-400 text-sm">
              <span className="material-symbols-outlined text-base text-accent-gold">mail</span>
              <span>{siteConfig.contact.email}</span>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">© 2024 {siteConfig.name}. All rights reserved.</p>
          <img
            alt="NDIS Registered Provider Logo"
            className="h-9 opacity-70"
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuCUCkbYcswhH1jQLDF4KMQbFj9mKG5S98zr8CPX8MITaXiZH0zQfAtPtuo7gx41f0sL9cTLk4V7cC9WcubLd2zdo9F-ZwQks7aj9LBLxL1RI-tzmJhnWTUXiTV-UNzG3SF6WhMPM50Jg20lkg6po6G0dHknbFt6XrHrcmZ_Tpv68moxG5iHirJjIG8o4atZobDuLqFC9wu_3XoczVb4nEPQSPVt8IS0B9mf2RJ21d1PfnOqbmLLSzKHc2vmBZ39DED-bInudMaIb2Y"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
